export default __webpack_public_path__ + "static/media/juego rio 2-26.b78cfe5c.png";